/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["app-duration-picker clr-input-container.clr-form-control{width:1.5rem;margin-right:.5rem}  app-duration-picker clr-select-container.clr-form-control{margin-top:.55rem}"];
export { styles as styles };

